import ApiService from "./ApiService"

export default {
    userInfo() {
        return ApiService().get('api/member-identity');
    },
    getOrganizations() {
        return ApiService().get('api/organizations');
    },
    search(search) {
        let params = new URLSearchParams();
        if(search.output)
            params.append('output', search.output);
        if(search.search && search.search.length > 0)
            params.append('term', search.search);
        let qs = params.toString();
        if(qs && qs.length > 0)
            qs = "?" + qs;
        return ApiService().get(`api/members/${search.offset}/${search.limit}${qs}`);
    },
    get(id) {
        return ApiService().get(`api/members/${id}`);
    },
    post(payload) {
        return ApiService().post('api/members', payload);
    },
    put(id, payload) {
        return ApiService().put(`api/members/${id}`, payload);
    },
    delete(id) {
        return ApiService().delete(`api/members/${id}`, {});
    }
}